<div class="update-customer-form pb-5">
  <div class="content row m-0" #updateCustomerContainer>
    <!-- Start Left Content -->

    <div class="ui-g-8 customer pl-4">
      <div class="ui-g-12 p-0">
        <div *ngIf="isCompatibilityBannerVisible" class="alert alert-danger flex-start-center">
          <i class="fal fa-exclamation-triangle mr-2"></i>
          <p class="m-0">
            Due to compliance, these fields are now mandatory. Please update the missing information when possible
          </p>
        </div>

        <!-- Company type -->
        <div class="p-0 pr-4 mt-30" [ngClass]="customer?.isMFCustomer ? 'ui-g-4':'ui-g-6'">
          <app-dropdown id="customer-type" listId="customer-type-list" class="width-100p" placeholder="Customer type"
            theme="primary" field="label" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
            [disabled]="defaultCustomer?.isFleetCustomer " [options]="customerTypes" [value]="customer?.customerType"
            [isDropdownIconVisible]="!defaultCustomer?.isFleetCustomer"
            (appSelect)="handleChange('customerType', $event)">
          </app-dropdown>
        </div>

        <div *ngIf="customer?.isFleetCustomer && customer?.isMFCustomer" class="ui-g-2 p-0 pr-4 mt-15">
          <div class="width-100p">
            <label class="font-gray-65 font-12">Fleet type</label>
            <div class="my-fleet-type-badge">{{customer?.MFC?.accountType || 'local'}}</div>
          </div>
        </div>
        <div class="ui-g-6 p-0" [ngClass]="!customer?.isMFCustomer ? 'pr-4':'pr-4'"
          *ngIf="customer?.isFleetCustomer && isMyFleetCenterEnabled">
          <div class="width-100p flex-end-center">
            <button class="my-fleet-center-btn width-100p mt-4" (click)="onChangeFleetConnection()"
              *ngIf="!customer?.isMFCustomer">
              <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1" />
              Connect to MyFleetCenter
            </button>

            <div class="dropdown-section" *ngIf="customer?.isMFCustomer">
              <app-content-overlay [dropshadow]="false" [showArrow]="false" showOnClick="true"
                [closeAfterAction]="closeAfterAction" right="0" width="100%" top="42px">
                <ng-template appTemplate="item">
                  <div class="dropdown-section-inner-wrapper">
                    <div class="icon">
                      <img src="assets/myFleetCenterIntegration-icon.svg" class="mr-1" />
                      Connected
                    </div>
                    |
                    <div class="filter-cross">
                      <i class="fal fa-chevron-down" *ngIf="!isDropdownOpen"></i>
                      <!-- <i class="fal fa-chevron-up" *ngIf="isDropdownOpen"></i> -->
                    </div>
                  </div>
                </ng-template>
                <ng-template appTemplate="overlay">
                  <div class="filter-overlay w-148px">
                    <div class="filter-option" (click)="onChangeFleetConnection()">
                      Update customer
                    </div>

                    <div class="filter-option bg-filter-option" (click)="onChangeFleetConnection('disconnect')">
                      Disconnect
                    </div>

                  </div>
                </ng-template>
              </app-content-overlay>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <!-- First Name -->
        <div *ngIf="!customer?.isFleetCustomer" class="ui-g-6 p-0 pr-4 mt-30">
          <div class="">
            <app-input id="customer-update-firstname" name="firstName" theme="primary" placeholder="First name*"
              [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.firstName" [errorMessage]="errors?.firstName"
              [maxLength]="25" [value]="customer.firstName" (appChange)="handleChange('firstName', $event)"
              (appFocus)="handleFocus('firstName')" (appBlur)="handleBlur('firstName')"></app-input>
          </div>
        </div>

        <!-- Last Name -->
        <div class="ui-g-6 p-0 pr-4 mt-30" *ngIf="!customer?.isFleetCustomer">
          <div class="">
            <app-input id="customer-update-lastname" name="lastName" theme="primary" placeholder="Last name*"
              [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.lastName" [errorMessage]="errors?.lastName"
              [maxLength]="25" [value]="customer.lastName" (appChange)="handleChange('lastName', $event)"
              (appFocus)="handleFocus('lastName')" (appBlur)="handleBlur('lastName')"></app-input>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <!-- Company Name -->
        <div class="ui-g-6 p-0 pr-4 mt-30" *ngIf="!customer.isFleetCustomer">
          <div class="">
            <app-input id="customer-update-companyname" name="companyName" theme="primary" placeholder="Company name"
              [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.companyName"
              [errorMessage]="errors?.companyName" [maxLength]="75" [value]="customer.companyName"
              (appChange)="handleChange('companyName', $event)" (appFocus)="handleFocus('companyName')"
              (appBlur)="handleBlur('companyName')"></app-input>
          </div>
        </div>

        <!-- Fleet name -->
        <div *ngIf="customer?.isFleetCustomer" class="ui-g-6 p-0 pr-4 mt-30">
          <div class="">
            <app-input id="customer-update-firstname" name="firstName" theme="primary" placeholder="Fleet name*"
              [disabled]="isValidMyFleetConnected()" [floatingLabel]="true" [fontSize]="14"
              [isInvalid]="errors?.firstName" [errorMessage]="errors?.firstName" [maxLength]="75"
              [value]="customer.firstName" (appChange)="handleChange('firstName', $event)"
              (appFocus)="handleFocus('firstName')" (appBlur)="handleBlur('firstName')"></app-input>
          </div>
        </div>

        <div *ngIf="customer?.isFleetCustomer && isMyFleetCenterEnabled" class="ui-g-6 p-0 pr-4 mt-30">
          <div class="">
            <app-input id="customer-update-fleetNumber" name="fleetNumber" theme="primary" placeholder="Fleet number"
              [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.fleetNumber"
              [disabled]="isValidMyFleetConnected()" [errorMessage]="errors?.fleetNumber" [maxLength]="75"
              [value]="customer.fleetNumber" (appChange)="handleChange('fleetNumber', $event)"
              (appFocus)="handleFocus('fleetNumber')" (appBlur)="handleBlur('fleetNumber')"></app-input>
          </div>
        </div>

        <!-- Full Name -->
        <div class="ui-g-6 p-0 pr-4 mt-30">
          <div class="">
            <app-input id="customer-update-fullname-qbo" name="fullNameQBO" theme="primary" placeholder="Display name*"
              [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.fullNameQBO || !isFullNameQboUnique"
              [disabled]="isValidMyFleetConnected()" [errorMessage]="errors?.fullNameQBO" [maxLength]="75"
              [value]="customer.fullNameQBO" (appChange)="handleChange('fullNameQBO', $event)"
              (appFocus)="handleFocus('fullNameQBO')" (appBlur)="handleBlur('fullNameQBO')"></app-input>
          </div>
        </div>

        <div *ngIf="customer?.isFleetCustomer && isMyFleetCenterEnabled" class="ui-g-6 p-0 pr-4 mt-30">
          <div class="">
            <app-input id="customer-update-accountType" name="accountType" theme="primary" placeholder="Company"
              [floatingLabel]="true" [fontSize]="14" [disabled]="isValidMyFleetConnected()"
              [value]="customer?.MFC?.companyName"></app-input>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0 mt-3" *ngIf="nameSuggestions?.length && !isFullNameQboUnique">
        <div class="flex-start-center">
          <p class="mb-0 customer-name-suggestion" (click)="selectNameSuggestion(name)"
            *ngFor="let name of nameSuggestions">
            {{ name }}
          </p>
        </div>
      </div>

      <!-- Phone -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="flex-column">
          <app-input id="customer-update-phone" name="phone" theme="primary" mask="(000) 000-0000" placeholder="Phone"
            [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.phone"
            [tooltipIconClass]="contactValidation?.phone?.icon" tooltipIconPosition="right"
            tooltipStyleClass="primary-contact-tooltip" [tooltipIconText]="contactValidation?.phone?.tooltip"
            [maxLength]="25" [value]="customer.phone" [disabled]="true" (appChange)="handleChange('phone', $event)"
            (appFocus)="handleFocus('phone')" (appBlur)="handleBlur('phone')">
          </app-input>

          <span class="flex-start-center pointer font-primary mt-1" (click)="openContactUpdateDialog()">
            <i class="fal fa-window"></i>
            <span class="font-12 pl-1">View and edit contacts</span>
          </span>
        </div>
      </div>

      <!-- Email Address -->
      <div class="ui-g-6 p-0 pr-4 mt-30">
        <div class="flex-column">
          <app-input id="customer-update-email" name="email" theme="primary" placeholder="Email" [fontSize]="14"
            [floatingLabel]="true" [isInvalid]="errors?.email" [disabled]="true"
            [tooltipIconClass]="contactValidation?.email?.icon" tooltipIconPosition="right"
            tooltipStyleClass="primary-contact-tooltip" [tooltipIconText]="contactValidation?.email?.tooltip"
            [value]="customer.email" (appChange)="handleChange('email', $event)" (appFocus)="handleFocus('email')"
            (appBlur)="handleBlur('email')"></app-input>

          <span class="flex-start-center pointer font-primary mt-1" (click)="openContactUpdateDialog()">
            <i class="fal fa-window"></i>
            <span class="font-12 pl-1">View and edit emails</span>
          </span>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <!-- Address Line 1 -->
        <div class="ui-g-8 p-0 pr-4 mt-30">
          <div class="">
            <app-input *ngIf="!isGoogleAddressSearchEnabled" id="customer-update-address1" name="address1"
              [label]="fieldsPlaceholder?.primaryAddress?.addLine1"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.addLine1" [errorMessage]="validate.address?.addLine1"
              [isInvalid]="validate.address?.addLine1" [value]="customer.address?.addLine1" [floatingLabel]="true"
              [maxLength]="160" (appChange)="handleChange('address.addLine1', $event, true)"
              (appFocus)="handleFocus('address.addLine1')"></app-input>
            <app-auto-complete *ngIf="isGoogleAddressSearchEnabled" id="customer-update-address1"
              textAreaId="customer-update-address1" listId="list-customer-update-address1" field="name" theme="inline"
              scrollHeight="160px" [label]="fieldsPlaceholder?.primaryAddress?.addLine1"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.addLine1" [floatingLabel]="true"
              [errorMessage]="validate.address?.addLine1" [isInvalid]="validate.address?.addLine1"
              [isLoading]="loader.address?.addLine1" [isDropdownIconVisible]="true" [fontSize]="14"
              [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.address?.addLine1"
              [suggestions]="addressResults?.address" [isTriggerChangeOnPaste]="false"
              (appCompletedMethod)="handleAddressSearch($event, customer.address, 'address')"
              (appSelect)="handleAddressSelect($event, 'address')" (appFocus)="handleFocus('address.addLine1')"
              (appClear)="handleAddressClear('address')" (appChange)="handleAddressChange($event, 'address')">
            </app-auto-complete>
          </div>
        </div>

        <!-- Zip Code -->
        <div class="ui-g-4 p-0 pr-4 mt-30">
          <div class="">
            <!-- <app-input id="customer-update-zip1" name="zip" theme="primary" placeholder="Zip / Postal code"
              [floatingLabel]="true" [fontSize]="14" [maxLength]="7" [isInvalid]="errors?.zip"
              [disabled]="isValidMyFleetConnected()" [errorMessage]="errors?.zip" [value]="customer?.address?.zip"
              (appChange)="handleChange('address.zip', $event, true)" (appFocus)="handleFocus('zip')"
              (appBlur)="handleBlur('address')">
            </app-input> -->
            <app-input id="customer-update-zip1" validationId="error-zip-1"
              [label]="fieldsPlaceholder?.primaryAddress?.zip" [placeholder]="fieldsPlaceholder?.primaryAddress?.zip"
              [errorMessage]="validate.address?.zip"
              [tooltipIconClass]="isZipCodeLoading.address && 'fal fa-spinner rotate'"
              [isInvalid]="validate.address?.zip" [value]="customer.address?.zip" [floatingLabel]="true" [maxLength]="7"
              (appChange)="handleChange('address.zip', $event, true)"
              (appFocus)="handleFocus('address.zip')"></app-input>
          </div>
        </div>

        <!-- Search City -->
        <div class="ui-g-4 p-0 pr-4 mt-30">
          <div class="">
            <!-- <app-auto-complete id="customer-update-city1" listId="customer-update-city1-list" placeholder="Search city"
              label="City" theme="primary" field="city" [floatingLabel]="true" [fontSize]="14"
              [suggestions]="addressCityResults" [disabled]="isValidMyFleetConnected()"
              [value]="renderCityName(customer?.address?.city,customer?.address?.stateCode)"
              (appSelect)="onAddressCitySelect($event, 'address')"
              (appCompletedMethod)="onAddressCitySearch($event, 'primary')" (appClear)="onAddressClear('primary')">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{ item.city }}, {{ item?.stateCode }}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
            <i id="customer-update-city" [hidden]="!customer?.address?.city"
              class="clear-city pointer fal fa-times font-gray-65" (click)="onClearCity('address')"></i> -->
            <app-auto-complete id="customer-update-city1" listId="customer-update-city1-list" field="city"
              theme="inline" scrollHeight="160px" [label]="fieldsPlaceholder?.primaryAddress?.city"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.city" [floatingLabel]="true"
              [isDropdownIconVisible]="true" [fontSize]="14" [errorMessage]="validate.address?.city"
              [isInvalid]="validate.address?.city" [closeOnSelection]="true" [value]="customer.address?.city"
              [suggestions]="addressCityResults" (appSelect)="handleCitySelect($event, 'address')"
              (appCompletedMethod)="handleCitySearch($event, customer.address, 'address')"
              (appFocus)="handleFocus('address.city')" (appClear)="handleCityClear('address')">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.city}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <div class="ui-g-4 p-0 pr-4 mt-30">
          <div class="">
            <app-auto-complete id="state-1" textAreaId="state-1" listId="list-state-1" field="name" theme="inline"
              scrollHeight="160px" [label]="fieldsPlaceholder?.primaryAddress?.state"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.state" [floatingLabel]="true"
              [errorMessage]="validate.address?.state" [isInvalid]="validate.address?.state"
              [isLoading]="loader.address?.state" [isDropdownIconVisible]="true" [fontSize]="14"
              [closeOnSelection]="true" [value]="customer.address?.state" [suggestions]="stateResults?.address"
              (appCompletedMethod)="handleStateSearch($event, customer.address, 'address')"
              (appSelect)="handleStateSelect($event)" (appFocus)="handleFocus('address.state')"
              (appClear)="handleStateClear('address')">
              <ng-template let-item appTemplate="item">
                <div class="flex-between-center">
                  <div class="font-14">
                    {{item.state}}, {{item?.stateCode}}
                  </div>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>

        <div class="ui-g-4 p-0 pr-4 mt-30">
          <div class="">
            <app-dropdown id="country-1" listId="country-list-1" class="width-100p" theme="primary" field="name"
              [label]="fieldsPlaceholder?.primaryAddress?.country"
              [placeholder]="fieldsPlaceholder?.primaryAddress?.country" [hasError]="validate.address?.country"
              [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true" [errorMessage]="validate.address?.country"
              [options]="countryOptions" [value]="{name: customer.address?.country}" [isDropdownIconVisible]="true"
              (appOpenDropdown)="handleFocus('address.country')"
              (appSelect)="handleCountrySelect($event.value, 'address')">
            </app-dropdown>
          </div>
        </div>
      </div>


      <!-- Address Line 2 -->
      <div class="ui-g-8 p-0 pr-4 mt-30">
        <div class="">
          <app-input *ngIf="!isGoogleAddressSearchEnabled" id="customer-update-address2" name="address2" theme="primary"
            placeholder="Business address" [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.address2"
            [errorMessage]="errors?.address2" [value]="customer?.businessAddress?.addLine1"
            [disabled]="isValidMyFleetConnected()" (appChange)="handleChange('businessAddress.addLine1', $event, true)"
            (appFocus)="handleFocus('address2')">
          </app-input>
          <app-auto-complete *ngIf="isGoogleAddressSearchEnabled" id="customer-update-address2"
            textAreaId="customer-update-address2" listId="list-customer-update-address2" field="name" theme="inline"
            scrollHeight="160px" [label]="fieldsPlaceholder?.secondaryAddress?.addLine1"
            [placeholder]="fieldsPlaceholder?.secondaryAddress?.addLine1" [floatingLabel]="true"
            [errorMessage]="validate.businessAddress?.addLine1" [isInvalid]="validate.businessAddress?.addLine1"
            [isLoading]="loader.businessAddress?.addLine1" [isDropdownIconVisible]="true" [fontSize]="14"
            [closeOnSelection]="true" [isSetPositionDynamically]="true" [value]="customer.businessAddress?.addLine1"
            [suggestions]="addressResults?.businessAddress" [isTriggerChangeOnPaste]="false"
            (appCompletedMethod)="handleAddressSearch($event, customer.businessAddress, 'businessAddress')"
            (appSelect)="handleAddressSelect($event, 'businessAddress')"
            (appFocus)="handleFocus('businessAddress.addLine1')" (appClear)="handleAddressClear('businessAddress')"
            (appChange)="handleAddressChange($event, 'businessAddress')"></app-auto-complete>
        </div>
      </div>

      <!-- Zip Code 2 -->
      <div class="ui-g-4 p-0 pr-4 mt-30">
        <div class="">
          <app-input id="customer-update-zip2" validationId="error-zip-2"
            [placeholder]="fieldsPlaceholder?.secondaryAddress?.zip" [errorMessage]="validate.businessAddress?.zip"
            [isInvalid]="validate.businessAddress?.zip"
            [tooltipIconClass]="isZipCodeLoading.businessAddress && 'fal fa-spinner rotate'"
            [value]="customer.businessAddress?.zip" [floatingLabel]="true" [maxLength]="7"
            (appChange)="handleChange('businessAddress.zip', $event, true)"
            (appFocus)="handleFocus('businessAddress.zip')"></app-input>
          <!-- <app-input id="customer-update-zip2" name="zip2" theme="primary" placeholder="Zip / Postal code"
            [floatingLabel]="true" [fontSize]="14" [maxLength]="7" [isInvalid]="errors?.zip2"
            [errorMessage]="errors?.zip2" [value]="customer?.businessAddress?.zip"
            [disabled]="isValidMyFleetConnected()" (appChange)="handleChange('businessAddress.zip', $event, true)"
            (appFocus)="handleFocus('zip2')" (appBlur)="handleBlur('businessAddress')">
          </app-input> -->
        </div>
      </div>

      <!-- Search City 2 -->
      <div class="ui-g-4 p-0 pr-4 mt-30 p-relative">
        <div class="">
          <!-- <app-auto-complete id="customer-update-city2" listId="customer-update-city2-list" placeholder="Search city"
            label="City" field="city" theme="primary" [floatingLabel]="true" [fontSize]="14"
            [disabled]="isValidMyFleetConnected()" [suggestions]="bAddressCityResults"
            [value]="renderCityName(customer?.businessAddress?.city, customer?.businessAddress?.stateCode)"
            (appSelect)="onAddressCitySelect($event, 'businessAddress')"
            (appCompletedMethod)="onAddressCitySearch($event, 'secondary')" (appClear)="onAddressClear('secondary')">
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">
                  {{ item.city }}, {{ item?.stateCode }}
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
          <i id="customer-update-city2-clear" [hidden]="!customer?.businessAddress?.city"
            class="clear-city pointer fal fa-times font-gray-65" (click)="onClearCity('businessAddress')"></i> -->
          <app-auto-complete id="customer-update-city2" listId="customer-update-city2-list" label="City" field="city"
            theme="inline" scrollHeight="160px" [placeholder]="fieldsPlaceholder?.secondaryAddress?.city"
            [floatingLabel]="true" [isDropdownIconVisible]="true" [fontSize]="14"
            [errorMessage]="validate.businessAddress?.city" [isInvalid]="validate.businessAddress?.city"
            [closeOnSelection]="true" [value]="customer.businessAddress?.city" [suggestions]="bAddressCityResults"
            (appSelect)="handleCitySelect($event, 'businessAddress')"
            (appCompletedMethod)="handleCitySearch($event, customer.businessAddress, 'businessAddress')"
            (appClear)="handleCityClear('businessAddress')">
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">
                  {{item.city}}, {{item?.stateCode}}
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>
      </div>

      <div class="ui-g-4 p-0 pr-4 mt-30">
        <div class="">
          <app-auto-complete id="state-2" textAreaId="state-2" listId="list-state-2" label="State" field="name"
            theme="inline" scrollHeight="160px" [placeholder]="fieldsPlaceholder?.secondaryAddress?.state"
            [floatingLabel]="true" [errorMessage]="validate.businessAddress?.state"
            [isInvalid]="validate.businessAddress?.state" [isDropdownIconVisible]="true" [fontSize]="14"
            [closeOnSelection]="true" [value]="customer.businessAddress?.state"
            [isLoading]="loader.businessAddress?.state" [suggestions]="stateResults?.businessAddress"
            (appSelect)="handleStateSelect($event, 'businessAddress')"
            (appCompletedMethod)="handleStateSearch($event, customer.businessAddress, 'businessAddress')"
            (appFocus)="handleFocus('businessAddress.state')" (appClear)="handleStateClear('businessAddress')">
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">
                  {{item.state}}, {{item?.stateCode}}
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>
      </div>

      <div class="ui-g-4 p-0 pr-4 mt-30">
        <div class="">
          <app-dropdown id="country-2" listId="country-list-2" class="width-100p" theme="primary" field="name"
            [placeholder]="fieldsPlaceholder?.secondaryAddress?.country" [hasError]="validate.businessAddress?.country"
            [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
            [errorMessage]="validate.businessAddress?.country" [options]="countryOptions"
            [value]="{name: customer.businessAddress?.country}" [isDropdownIconVisible]="true"
            (appSelect)="handleCountrySelect($event.value, 'businessAddress')">
          </app-dropdown>
        </div>
      </div>

      <div class="ui-g-12 p-0 mt-30 d-flex align-items-center">
        <div class="ui-g-6 p-0">
          <p class="field-side-label padding-zero font-12 mb-0" id="update-communication-preference">Communication
            preference</p>
          <div>
            <span class="pr-4">
              <app-checkbox inputId="cb-customer-update-email" label="Email" [isChecked]="customer.contactOnEmail"
                [disabled]="!customer.email || isValidMyFleetConnected()"
                (appChange)="handleChange('contactOnEmail', $event)"
                id="update-communication-preference-email"></app-checkbox>
            </span>
            <span>
              <app-checkbox inputId="cb-customer-update-phone" label="Mobile" [isChecked]="customer.contactOnPhone"
                id="update-communication-preference-mobile" [disabled]="!customer.phone || isValidMyFleetConnected()"
                (appChange)="handleChange('contactOnPhone', $event)"></app-checkbox>
            </span>
          </div>
        </div>
        <div class="pref-language ui-g-6 p-0 pr-4 pl-2" *ngIf="companyLocalization">
          <p class="mb-1">Preferred Language</p>
          <div class="flex-start-center">
            <span class="pr-1 radio-inline">
              <app-radio-button [selectedValue]="customer?.preferredLanguage" label="English" value="EN"
                (appChange)="switchLanguage('EN')"></app-radio-button>
            </span>

            <span class="pr-1 ml-4">
              <app-radio-button [selectedValue]="customer?.preferredLanguage" label="French" value="FR"
                (appChange)="switchLanguage('FR')"></app-radio-button>
            </span>
          </div>
        </div>
      </div>

      <div class="ui-g-12 pr-2 p-0 mt-30">
        <div class="ui-g-6 p-0 custom-switch-pill">
          <div class="">
            <app-switch-pill id="customer-update-tax-exampt" label="Tax exempt" [isActive]="customer.taxExempt"
              [disabled]="isValidMyFleetConnected()" (appChange)="handleChange('taxExempt', $event)"
              position="end"></app-switch-pill>
          </div>
        </div>
        <div class="ui-g-6">
          <app-textarea textAreaId="customer-update-notes" name="notes" placeholder="Pinned notes" theme="primary"
            [maxLength]="2000" [floatingLabel]="true" [value]="customer.notes" [rows]="3" [autoGrow]="true"
            [disabled]="isValidMyFleetConnected()" [maxAutoGrowHeight]="38" [autoFocus]="focus?.notes"
            (appChange)="handleChange('notes', $event)">
          </app-textarea>
        </div>
      </div>

      <div class="ui-g-6 p-0 pr-4 mt-21" *ngIf="customer?.taxExempt">
        <app-dropdown *ngIf="customer?.taxExempt" id="tax-exempt-reason" listId="tax-exempt-reason-list"
          class="width-100p" placeholder="Reason for tax-exemption*" theme="primary" field="reason"
          [disabled]="isValidMyFleetConnected()" [hasError]="validate?.taxExemptReason"
          [errorMessage]="validate?.taxExemptReason" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true"
          [autoFocus]="isTaxDropdownFocused" [options]="qboTaxExemptReasons" [value]="customer?.taxExemptReason"
          [isDropdownIconVisible]="true" (appSelect)="handleChange('taxExemptReason', $event)">
        </app-dropdown>
      </div>

      <!-- Preferred location -->
      <div *ngIf="isMultiLocationEnabled && isPreferredLocationsEnabled" class="ui-g-12 p-0 mt-30 p-relative">
        <div class="ui-g-6 p-0" [ngClass]="{ active: openPreferredLocation }">
          <app-auto-complete id="customer-update-location" textAreaId="preferred-location"
            [disabled]="isValidMyFleetConnected()" listId="customer-update-location-list"
            placeholder="Preferred location*" label="Preferred location*" field="name" theme="primary"
            [floatingLabel]="true" [fontSize]="14" [suggestions]="locationSuggestions"
            [autoFocus]="openPreferredLocation" [isInvalid]="errors?.preferredLocation"
            [errorMessage]="errors?.preferredLocation" [value]="customer?.preferredLocation?.name"
            (appSelect)="onLocationSelect($event)" (appFocus)="showSuggestions('pLocation')"
            (appCompletedMethod)="onLocationSearch($event)" (appClear)="onLocationClear()">
            <ng-template let-item appTemplate="item">
              <div class="flex-between-center">
                <div class="font-14">
                  {{ item.name }}
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
          <i id="customer-update-city2-clear" [hidden]="!customer?.preferredLocation"
            class="clear-city pointer fal fa-times font-gray-65" (click)="onLocationClear()"></i>
        </div>
      </div>

      <div class="ui-g-12 p-0 pr-4 mt-30">
        <app-tags-list id="customer-update-tags" buttonId="btn-add-customer-update-tags" addTagTitle="Add tags"
          vPosition="top" [tags]="tags" [type]="tagTypeCustomer" [selectedTags]="customer?.tags"
          [disabled]="isValidMyFleetConnected()" [stopPropagationOnDelete]="true" [fontSize]="11"
          [hasCreateOption]="true" [isDeleteable]="true" (appTagDeleted)="handleTagDelete($event)" (appSelect)="onTagSelect($event)"
          (appDelete)="onTagDelete($event)" [tagHeight]="21" (appUpdateTagList)="updateCustomerTagList($event)"
          (appCreateTag)="onTagCreate($event)">
        </app-tags-list>
      </div>

      <div class="mt-30 mb-2">
        <div class="">
          <!-- <app-textarea textAreaId="customer-update-notes" name="notes" placeholder="Pinned notes" theme="primary"
            [maxLength]="2000" [floatingLabel]="true" [value]="customer.notes" [rows]="3" [autoGrow]="true"
            [disabled]="isValidMyFleetConnected()" [maxAutoGrowHeight]="38" [autoFocus]="focus?.notes"
            (appChange)="handleChange('notes', $event)">
          </app-textarea> -->
        </div>
      </div>

      <div class="ui-g-12 p-0 pr-4 mt-30" *ngIf="isAppleDevice">
        <div class="iphone-dummy-height"></div>
      </div>

      <div class="ui-g-12">
        <div class="footer">
          <div class="footer_contents">
            <button id="customer-update-btn-save" class="btn btn-submit customer-btn" [disabled]="isProcessing"
              (click)="onSubmit()">
              <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
              <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Left Panel -->

    <!-- Start Right Panel -->
    <div class="ui-g-4 other p-0">
      <app-upcoming-appointment [isMarketingEnabled]="isMarketingEnabled" [isLoadingAppointment]="isLoadingAppointment"
        [appointments]="appointments" [vehicles]="vehicles" [exsistingEstimate]="estimate" [user]="customer">
      </app-upcoming-appointment>
    </div>
    <!-- End Right Panel -->
  </div>
</div>
